module.exports = __webpack_public_path__ + "img/特产店铺4.093d0b7d.png";